<template>
  <div class="form-page">
    <g-title tag="h1" size="s">
      Tack för allt du gjort - det var superbra!
    </g-title>
    <p>
      Om du vill och orkar kan du hjälpa oss genom att svara på några frågor om:
      <br />
      <br />
    </p>
    <template v-for="(block, index) in filteredQuestionBlocks">
      <router-link
        :key="'link' + index"
        :to="{ name: 'question-block', params: { id: block.id } }"
      >
        <g-button>{{ block.Title }}</g-button>
      </router-link>
    </template>
    <router-link :to="{ name: 'story-end' }">
      <g-button>Avsluta undersökningen</g-button>
    </router-link>
  </div>
</template>
<script>
import GET_QUESTION_BLOCKS from '@/graphql/question-block/GetQuestionBlocks.gql';

export default {
  apollo: {
    questionBlocks: {
      query: GET_QUESTION_BLOCKS
    }
  },
  data() {
    return {
      questionBlocks: [],
      formData: {}
    };
  },

  computed: {
    filteredQuestionBlocks() {
      const victim = 5;
      let internet = [9, 10];
      internet = internet[Math.floor(Math.random() * internet.length)];
      const attitude = 12;
      const perpetrator = 13;
      const placed = 14;
      const ownStory = 8;

      if (this.questionBlocks.length == 0) return [];

      if (
        this.formData?.placerad_utanfor_hemmet &&
        this.formData.placerad_utanfor_hemmet === 'ja'
      ) {
        let blocks = this.questionBlocks.filter(
          block =>
            block.id == victim ||
            block.id == perpetrator ||
            block.id == placed ||
            block.id == ownStory
        );

        let ownStoryIndex = blocks.findIndex(block => block.id == ownStory);
        blocks.push(blocks.splice(ownStoryIndex, 1)[0]);

        return blocks;
      } else if (this.formData.age < 14) {
        let blocks = this.questionBlocks.filter(
          block =>
            block.id == victim ||
            block.id == perpetrator ||
            block.id == ownStory
        );
        let ownStoryIndex = blocks.findIndex(block => block.id == ownStory);
        blocks.push(blocks.splice(ownStoryIndex, 1)[0]);

        return blocks;
      } else {
        let blocks = this.questionBlocks.filter(
          block =>
            block.id == victim ||
            block.id == internet ||
            block.id == attitude ||
            block.id == perpetrator ||
            block.id == ownStory
        );
        let ownStoryIndex = blocks.findIndex(block => block.id == ownStory);
        blocks.push(blocks.splice(ownStoryIndex, 1)[0]);

        return blocks;
      }
    }
  },

  mounted() {
    const sessionItem = window.sessionStorage.getItem('userObject');
    if (!sessionItem) return;
    let userObject = JSON.parse(sessionItem);
    this.formData = userObject['formData'];
  }
};
</script>

<style scoped></style>
